export function getCssClassForUpDownEqual(isUp: boolean | null | undefined) {
    if (isUp) {
        return 'text-emerald-600';
    }
    if (isUp === false) {
        return 'text-red-600';
    }
    return 'text-neutral-600';
}
